export default "__VITE_ASSET__e8cec966__"